"use client"
/* */
const getActionGroupSlot = (props) => {
  const { slot: slotFromProps, ...buttonProps } = props;
  const guessedSlot = buttonProps.color === void 0 || buttonProps.color === "primary" || buttonProps.color === "danger" || buttonProps.color === "accent" ? "primary" : "abort";
  return slotFromProps ?? guessedSlot;
};

export { getActionGroupSlot };
//# sourceMappingURL=getActionGroupSlot.mjs.map
